export class FileIdReq{
    fileId : number;
}